//bao migrate skip
import template from "./email-picker-template.html";
import * as EMailPickerModule from "./email-picker-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new EMailPickerModule.EMailPickerComponent(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};